<template>
  <div class="links">
    <div class="links__items">
      <div
        v-for="(item, i) in items"
        :key="`item_${i}`"
        class="links__item"
      >
        <BaseLink :href="item.href" class="links__link">
          <span class="links__name" v-html="item.name" />
          <!-- <BaseIcon name="long_arrow" class="links__arrow" /> -->
        </BaseLink>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLink from '@/components/BaseLink.vue';
// import BaseIcon from '@/components/BaseIcon.vue';
// :class="modifiers"
// import BaseTitle from '@/components/BaseTitle.vue';
// import Bonus from '@/assets/images/bonus.svg';

export default {
  name: 'TheLinks',
  components: {
    BaseLink,
    // BaseIcon,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    // size: {
    //   type: String,
    //   default: '',
    // },
  },
  // computed: {
  //   modifiers() {
  //     return {
  //       [`links_size_${this.size}`]: Boolean(this.size),
  //     };
  //   },
  // },
  // props: {
  //   isHintsVisible: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  // data() {
  //   return {
  //     name: '',
  //     email: '',
  //     message: '',
  //   };
  // },
  // staticData: () => ({
  //   menu: slides.filter((slide) => slide.addToMenu),
  // }),
  // computed: {
  //   isIntroPage() {
  //     return this.$route.path === paths.intro;
  //   },
  // },
  // methods: {
  //   checkClick(e) {
  //     if (e.target.closest('.header__nav')) return;
  //     this.hideMenu();
  //   },
  //   showMenu() {
  //     this.isMenuOpen = !this.isMenuOpen;
  //   },
  //   hideMenu() {
  //     this.isMenuOpen = false;
  //   },
  // },
};
</script>

<style lang="stylus">
.links
  display block
  font-size 1.3em
  // padding-right 1em

  // &_size_xxs
  //   font-size 0.7em

  // &_size_xs
  //   font-size 0.8em

  // &_size_s
  //   font-size 0.9em

  // &_size_m
  //   font-size 1.12em

  // &_size_l
  //   font-size 1.2em

  // &_size_xl
  //   font-size 1.3em

  // &_size_xxl
  //   font-size 1.4em

  &__items
    +landscape()
      display flex
      flex-wrap wrap
      justify-content space-between

  &__item
    margin-top 1.25em
    &:first-child
      margin-top 0
    +landscape()
      flex 0 0 50%
      max-width calc(50% - 1.5em)
      margin 0
      &:not(:nth-child(-n+2))
        margin-top 1.25em

  &__link
    // white-space nowrap
    &:after
      content '\2002\2192'
      display inline
      vertical-align middle
      //font-family Tahoma // Georgia
      font-size 1.4em
      //margin-top 0.1em
      // background-color red
      //height 0.5em

  &__name
    color #22215B
    font-weight 600
    line-height 1.5
    // white-space normal
    border-bottom solid 1px alpha(@color, 30%)

  // &__arrow
  //   display inline-block
  //   vertical-align middle
  //   height 0.6em
  //   margin-left 0.7em
  //   margin-top 0.1em
</style>
